import api from 'api'
import { queryParamSerializer } from 'lib/api/queryParamSerializer'

export type TimeClock = {
  id: number
  vendorClockId: string
  companyId: number
  locationId: number
  manufacturer: string
  model: string
  createdAt: string
  updatedAt: string
  deletedAt: string | null
}

export type ListTimeClocksParams = {
  companyId: number
  locationId?: number
  cursor?: string
  includeDeleted?: boolean
}

export type ListTimeClocksResponse = {
  items: TimeClock[]
  nextCursor: string | null
}

export async function listTimeClocks(
  params: ListTimeClocksParams
): Promise<ListTimeClocksResponse> {
  const result = await api.get<ListTimeClocksResponse>('/admin/time_clock', {
    params: {
      companyId: params.companyId,
      locationId: params.locationId,
      cursor: params.cursor,
      includeDeleted: params.includeDeleted ?? false,
    },
    paramsSerializer: queryParamSerializer,
  })
  return result.data
}
